import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { useVersionCheck } from "@/lib/useVersionCheck";
import { Button } from "@/components/ui/button";

// Routes where yanking the page out from under the user would lose data.
// On these routes we suppress the banner so users can finish what they're
// doing — the chunk-reload safety net in App.js still catches actual failures.
const SUPPRESS_PREFIXES = [
  "/booking-review",
];

export default function UpdateBanner() {
  const updateAvailable = useVersionCheck(true);
  const location = useLocation();

  const suppressed = SUPPRESS_PREFIXES.some((p) =>
    location.pathname.startsWith(p),
  );

  // Once a new version is out, the next page change loads it for real, so
  // nobody keeps reading figures from old code (Fan 2026-10-13).  Moving
  // between pages already drops unsaved in-page state, so nothing extra is lost.
  const lastPath = useRef(location.pathname);
  useEffect(() => {
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;
    if (updateAvailable && !suppressed) {
      window.location.reload();
    }
  }, [location.pathname, updateAvailable, suppressed]);
  if (!updateAvailable || suppressed) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-slate-900 text-white px-4 py-3 rounded-lg shadow-lg border border-slate-700 flex items-center gap-3 max-w-md">
      <RefreshCw className="w-4 h-4 text-emerald-400 flex-shrink-0" />
      <div className="text-sm flex-1">
        A new version of BR OS is available.
      </div>
      <Button
        size="sm"
        variant="secondary"
        className="bg-card text-foreground hover:bg-muted"
        onClick={() => window.location.reload()}
      >
        Reload now
      </Button>
    </div>
  );
}
